export function clearLocalStorage() {
  const uulimsValue = localStorage.getItem("UULIMS"); // Save UULIMS value
  localStorage.clear();                               // Clear all localStorage
  if (uulimsValue !== null) {
    localStorage.setItem("UULIMS", uulimsValue);      // Restore UULIMS if it existed
  }
}
